// extracted by mini-css-extract-plugin
export default {"digitDownAnim":"DigitalClock_digitDownAnim__UtKuP","digitDown":"DigitalClock_digitDown__yweFs","twoPoints":"DigitalClock_twoPoints__9fzed"};